import type { ThisType } from '~/src/helpers/analytics-ref/analytics-ref.helper.types';

/**
 * Used in Module Federation
 */
function setDataAnalyticsRef<T extends string | number | symbol>(
    filedName: ThisType<T>['filedName'],
    node: Element | null,
    dataSuccessIconForAnalyticsRef: ThisType<T>['dataSuccessRef'],
) {
    const getNewValueFromCallbackRef = () => {
        if (node) {
            return {
                [filedName]: true,
            };
        }

        return { [filedName]: false };
    };

    dataSuccessIconForAnalyticsRef.current = {
        ...dataSuccessIconForAnalyticsRef.current,
        ...getNewValueFromCallbackRef(),
    };
}

/**
 * Used in Module Federation
 */
export function checkFieldsSuccessFillForAnalytics<T extends string | number | symbol>(
    this: ThisType<T>,
    node: Element | null,
) {
    setDataAnalyticsRef(this.filedName, node, this.dataSuccessRef);
    const { analyticsWasSend, ...rest } = this.dataSuccessRef.current;
    if (Object.values(rest).every(Boolean) && !analyticsWasSend) {
        this.sendAnalytics();
        this.dataSuccessRef.current.analyticsWasSend = true;
    }
}

export default checkFieldsSuccessFillForAnalytics;